export default __webpack_public_path__ + "static/media/kbc_icon.0728696f.svg";